/** In this file entities are declared */
import { BASE_URL } from "../../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import globalMessages from "../../intl/globalMessages";
import { FormattedMessage } from "react-intl";
import React from "react";

const ModuleDefinition = {
  /** name is the title */
  name: "Forms",
  /** entityName is used to link with the constants */
  entityName: "questionnaire",
  restConfig: {
    baseURL: `${BASE_URL}`,
    // baseURL: 'http://localhost:9080',
    create: {
      url: ({ propertyTicker }) => `/api/backoffice/${propertyTicker}/questionnaires`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: ({ propertyTicker }) => `/api/backoffice/${propertyTicker}/questionnaires`,
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ propertyTicker, ticker }) =>
        `/api/backoffice/${propertyTicker}/questionnaires/${ticker ? ticker : ""}`,
      method: "get",
    },
    delete: {
      url: ({ propertyTicker, id }) => `/api/backoffice/${propertyTicker}/questionnaires/${id}`,
      method: "delete",
      resetCache: true,
    },
  },
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Translations",
    widget: "translations",
    entityProperty: "translations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: true,
  },
  reorder: true,
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "active",
        widget: "singleSwitch",
        toggleAction: true,
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "dependers",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          EXTRA: "Extra",
          GUEST_FORM: "Guest Form",
          CANCELLATION_FORM: "Cancellation Popup",
        },
        displayName: "Enable for",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Form Ticker",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "dependers",
        displayName: "Enable for:",
        widget: "selector",
        optionDisplay: {
          EXTRA: {
            label: "Extras",
          },
          GUEST_FORM: {
            label: "Guest form",
          },
          CANCELLATION_FORM: {
            label: "Cancellation popup",
          },
        },
        defaultValue: "EXTRA",
      },
      {
        fieldName: "dependersBoxes",
        widget: "multicheckbox",
        selectables: true,
        selectAllText: "Select all",
        selectNoneText: "Select none",
        visible: ({ formValues }) => {
          return formValues.dependers === "EXTRA";
        },
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "fields",
        displayName: "Constraints",
        introductionText: "introduction text",
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        nestedTitle: "Edit",
        sortName: "position",
        defaultValue: [],
      },
    ],
  },
  validation: {
    ticker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    dependers: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["EXTRA", "GUEST_FORM", "CANCELLATION_FORM"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "EXTRA",
    },
    fields: {
      type: "Arr",
      constraints: {
        length: {
          minimum: 1,
          message: <FormattedMessage {...globalMessages.requireAtLeastOneRestriction} />,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
